import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';

const NavigationBar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <Navbar bg="light" expand="lg" expanded={expanded} className="shadow-sm" style={{ zIndex: 1030 }}>
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
          <img src="/logo.png" alt="Shruti Shah & Co. - Chartered Accountants" height="40" width="36" className="me-2" loading="eager" />
          <span className="visually-hidden">Shruti Shah & Co. - Chartered Accountants</span>
          Shruti Shah & Co.
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(expanded ? false : true)} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>Home</Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={() => setExpanded(false)}>About Us</Nav.Link>
            <NavDropdown title="Services" id="services-dropdown">
              <NavDropdown.Item as={Link} to="/services?service=audit-assurance" onClick={() => setExpanded(false)}>Audit and Assurance</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services?service=transaction-support" onClick={() => setExpanded(false)}>Transaction Support</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services?service=valuation" onClick={() => setExpanded(false)}>Valuation</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services?service=income-tax" onClick={() => setExpanded(false)}>Income Tax</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services?service=corporate-laws" onClick={() => setExpanded(false)}>Corporate & Allied Laws</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services?service=indirect-tax" onClick={() => setExpanded(false)}>Indirect Tax</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services?service=business-advisory" onClick={() => setExpanded(false)}>Business Advisory</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to="/career" onClick={() => setExpanded(false)}>Career</Nav.Link>
            <Nav.Link as={Link} to="/blog" onClick={() => setExpanded(false)}>Knowledge Centre</Nav.Link>
            <Nav.Link as={Link} to="/team" onClick={() => setExpanded(false)}>Team</Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={() => setExpanded(false)}>Contact Us</Nav.Link>
          </Nav>
          <Nav>
            {user ? (
              <>
                <Nav.Link as={Link} to="/dashboard" onClick={() => setExpanded(false)}>Dashboard</Nav.Link>
                {user.role === 'admin' && (
                  <Nav.Link as={Link} to="/admin" onClick={() => setExpanded(false)}>Admin</Nav.Link>
                )}
                <Nav.Link onClick={() => { handleLogout(); setExpanded(false); }}>Logout</Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login" onClick={() => setExpanded(false)}>Login</Nav.Link>

              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
